import { getStoredUser } from "@/lib/api";

/**
 * Incident `status` is shared across all orgs. Whether *our* org has acted is
 * determined by `service_statuses[<org_type>]` (absent = not responded).
 */
export function hasOrgResponded(incident, orgType = getStoredUser()?.org_type) {
  if (!orgType || !incident || typeof incident !== "object") return false;
  return Boolean(incident.service_statuses?.[orgType]);
}

/** Keep only incidents the current org has not yet responded to. */
export function filterUnrespondedByOrg(rows, orgType = getStoredUser()?.org_type) {
  if (!Array.isArray(rows)) return [];
  return rows.filter((row) => !hasOrgResponded(row, orgType));
}
